import { render, staticRenderFns } from "./StockReport.vue?vue&type=template&id=00a3814f&"
import script from "./StockReport.vue?vue&type=script&lang=js&"
export * from "./StockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a3814f')) {
      api.createRecord('00a3814f', component.options)
    } else {
      api.reload('00a3814f', component.options)
    }
    module.hot.accept("./StockReport.vue?vue&type=template&id=00a3814f&", function () {
      api.rerender('00a3814f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/StockReport.vue"
export default component.exports